<!-- <template>
    <div class="flex-col items-start w-full">
        <label v-if="label" class="mb-2">{{ label }}</label>
        <div
            class="relative w-full"
            :class="{ 'cursor-not-allowed opacity-50 bg-gray-200 rounded-lg': disabled }"
            @click="!disabled && toggleDropdown"
        >
            <div
                class="flex items-center border rounded-lg p-4 cursor-pointer"
                :class="{ 'cursor-not-allowed': disabled, 'bg-gray-200': disabled }"
            >
                <span v-if="icon" class="mr-2">
                    <AppIcon
                        :icon="icon"
                        class="text-gray-600"
                        width="20"
                        height="20"
                    />
                </span>
                <span class="w-full">{{ selectedOptionLabel }}</span>
                <span class="ml-2">
                    <AppIcon
                        icon="mdi:chevron-down"
                        class="text-gray-600 w-4 h-4"
                    />
                </span>
            </div>
            <ul
                v-if="isOpen"
                class="absolute mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-40 select-dropdown"
            >
                <li
                    v-for="option in options"
                    :key="option.value"
                    @click="selectOption(option)"
                    class="p-2 hover:bg-gray-100 cursor-pointer"
                >
                    {{ option.label }}
                </li>
                <li
                    v-if="options.length === 0"
                    class="p-2 text-gray-500 cursor-default"
                >
                    Not Found
                </li>
            </ul>
        </div>
    </div>
</template> -->

<template>
    <div class="flex-col items-start w-full">
        <!-- Label -->
        <label v-if="label" class="mb-2">{{ label }}</label>

        <!-- Dropdown Trigger -->
        <div class="relative w-full" :class="{ 'cursor-not-allowed opacity-50 bg-gray-200 rounded-lg': disabled }">
            <div data-testid="select-trigger" :data-open="isOpen ? 'true' : 'false'"
                class="flex items-center border rounded-lg p-4 cursor-pointer bg-white border-blue-500"
                :class="{ 'cursor-not-allowed': disabled }" @click="toggleDropdown">
                <!-- Icon di Kiri (Opsional) -->
                <span v-if="icon" class="mr-2">
                    <AppIcon :icon="icon" class="text-gray-600" width="20" height="20" />
                </span>

                <!-- Label Opsi Terpilih -->
                <span class="w-full">{{ selectedOptionLabel }}</span>

                <!-- Icon Chevron di Kanan -->
                <span class="ml-2">
                    <AppIcon :icon="isOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="text-gray-600 w-4 h-4" />
                </span>
            </div>

            <!-- Dropdown Options -->
            <ul v-if="isOpen" data-testid="select-panel"
                class="absolute mt-1 w-full bg-white border border-blue-200 rounded-lg shadow-lg z-50 select-dropdown max-h-48 overflow-y-auto">
                <li v-for="option in options" :key="option.value" @click="selectOption(option)"
                    data-testid="select-option" :data-value="option.value"
                    class="p-2 hover:bg-blue-100 cursor-pointer">
                    {{ option.label }}
                </li>
                <li v-if="options.length === 0" class="p-2 text-gray-500 cursor-default">
                    No options available
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseSelect",
    props: {
        label: {
            type: String,
        },
        icon: {
            type: String,
        },
        placeholder: {
            type: String,
            default: "Select an option",
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        selectedOptionLabel() {
            const selectedOption = this.options.find(
                (option) => option.value === this.modelValue
            );
            return selectedOption ? selectedOption.label : this.placeholder;
        },
    },
    methods: {
        toggleDropdown() {
            if (!this.disabled) {
                this.isOpen = !this.isOpen;
            }
        },
        selectOption(option) {
            if (!option || option.value === undefined) {
                console.warn("Invalid option selected:", option);
                return;
            }
            this.$emit("update:modelValue", option.value);
            this.isOpen = false; // Tutup dropdown setelah memilih opsi
        },
        handleClickOutside(event) {
            if (this.isOpen && !this.$el.contains(event.target)) {
                this.isOpen = false;
            }
        },
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    watch: {
        modelValue(newValue) {
            const selectedOption = this.options.find(
                (option) => option.value === newValue
            );
            if (!selectedOption) {
                console.warn("Invalid modelValue:", newValue);
                this.$emit("update:modelValue", this.options[0]?.value || "");
            }
        },
    },
};
</script>

<style scoped>
.select-dropdown {
    max-height: 200px;
    overflow-y: auto;
    z-index: 100;
}

.cursor-not-allowed {
    cursor: not-allowed;
    opacity: 0.5;
}

.hover\:bg-blue-100:hover {
    background-color: #ebf8ff;
}
</style>